import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import YEAR_QUARTERSLISTING from '../quarters/year-quarters-listing';
import YEAR_CURRENTYEARGOALS from './year-current-year-goals';

export default function YEAR_CURRENTYEAR({ activeYear, refreshYear }) {
  const year = activeYear[0];
  const [goals, setGoals] = useState([]);
  const [endDate, setEndDate] = useState(year.endDate.slice(0, 10));
  const [refreshVersion, setRefreshVersion] = useState(0);
  const [error, setError] = useState('');
  const fetchGoals = useCallback(async () => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_WEB_URL}api/goals/get-goals-for-year`, { yearId: year._id }, { withCredentials: true });
      if (!Array.isArray(data)) throw new Error();
      setGoals(data);
      setError('');
    } catch { setError('Unable to load your yearly goals. Please try again.'); }
  }, [year._id]);
  useEffect(() => { fetchGoals(); }, [fetchGoals]);
  useEffect(() => { setEndDate(year.endDate.slice(0, 10)); }, [year.endDate]);
  const refreshGoals = async () => {
    await fetchGoals();
    setRefreshVersion(value => value + 1);
  };
  const saveEndDate = async event => {
    event.preventDefault();
    try {
      await axios.put(`${process.env.REACT_APP_WEB_URL}api/year/${year._id}`, { endDate }, { withCredentials: true });
      await refreshYear();
      toast.success('Year end date updated.');
    } catch { toast.error('Unable to update the year end date.'); }
  };

  return <div className="row year-overview">
    <div className="col-md-6 col-12">
      <h3>Yearly Goals — {goals.reduce((total, goal) => total + (goal.points || 0), 0)} points</h3>
      <form onSubmit={saveEndDate}>
        <p>Start date: {new Date(year.startDate).toLocaleDateString('en-GB')}</p>
        <label htmlFor="current_year_end_date">Year end date</label>
        <input type="date" id="current_year_end_date" value={endDate} required onChange={event => setEndDate(event.target.value)} />
        <button type="submit">Update end date</button>
      </form>
      <p>Edit a goal to move it between years or quarters while keeping its progress.</p>
      {error && <p role="alert">{error} <button onClick={fetchGoals}>Try again</button></p>}
      <YEAR_CURRENTYEARGOALS currentYearGoals={goals} refreshGoals={refreshGoals} />
    </div>
    <div className="col-md-6 col-12"><YEAR_QUARTERSLISTING yearId={year._id} refreshVersion={refreshVersion} refreshGoals={refreshGoals} /></div>
  </div>;
}
